// extracted by mini-css-extract-plugin
export default {"header":"_d41b3527"};